//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      billing: null,
      shipping: null,
      source: 'user'
    };
  },
  created: function created() {
    var _this = this;

    App.event.listen('billing.changed', function (billing) {
      return _this.billing = billing;
    });
    App.event.listen('shipping.changed', function (shipping) {
      return _this.shipping = shipping;
    });
    App.event.listen('shipping.source.changed', function (_ref) {
      var who = _ref.who;
      _this.source = who;
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/checkout-progress/components/CheckoutProgress.vue
// module id = Rly4
// module chunks = 4